import { IdObject } from "projects/assist/src/app/_shared/models/basicDto";
import { MemberAssignedFunctionBasicDto } from "projects/assist/src/app/person/models/assigned-function";
import { PersonDto, PersonForReviewDto } from "projects/assist/src/app/person/models/person";
import { WorkingYear } from "../../person/models/working-year";

export enum MemberStatus {
  INVITED = 1,
  HAS_REMARK,
  CONFIRMED,
  DENIED,
  STOPPED,
}

export interface MemberWorkingyear extends IdObject<number> {
  WorkingYearId: number;
  WorkingYear: WorkingYear;
}

export interface MemberList extends MemberWorkingyear {
  Number: number | null;
  ExportCode: string;
  Person: PersonDto;
  PublicSavedPerson: PersonDto | null;
  ReceivedHealthInsuranceCertificateOn: Date | null;
  PublicSavedPersonId: number | null;
  Saldo: number | null;
  StatusId: MemberStatus | null;
  StatusModifiedDate: Date | null;
  Remark: string;
  NumberFederation: string;
}

export interface MemberPublic extends MemberList {
  FamilyMemberNr: number | null;
  MemberMoneyTeam1: number | null;
  FamilyDiscount: number | null;
  SocialDiscount: number | null;
  InvalidDiscount: number | null;
  OtherDiscount: number | null;
  InsuranceFee: number | null;
  Surplus: number | null;
  PayedAmount: number | null;
  AssignedFunctions: MemberAssignedFunctionBasicDto[];

  DroppedOut: boolean | null;
  Person: PersonForReviewDto;
}

export interface Member extends MemberPublic {
  SubscriptionDate: Date | null;
  StartDate: Date | null;
  EndDate: Date | null;
  PersonId: number | null;
  Payed: boolean | null;
  MemberTypeId: number | null;
  OrganizationId: number | null;
  NumberFederation: string;
  NumberBond: number | null;
  MemberMoneyTeam1: number | null;
  MemberMoneyTeam2: number | null;
  MemberMoneyTeam3: number | null;
  MemberMoneyTeam4: number | null;
  MemberMoneyTeam5: number | null;
  FamilyDiscount: number | null;
  SocialDiscount: number | null;
  InvalidDiscount: number | null;
  OtherDiscount: number | null;
  InsuranceFee: number | null;
  Surplus: number | null;
  PayedAmount: number | null;
  MemberMoneyPaidOnDate: Date | null;
  MemberMoneyIsNoLongerCollectible: boolean;
  ExtraTrainings: string;
  CompetitionDate: Date | null;
  DateOfDropout: Date | null;
  YearDropout: number | null;
  YearDropoutMinusOne: number | null;
  DropOutHasBeenProcessed: boolean | null;
  HasCopiedVzfData: boolean | null;
  TeamNames: string[];
  FirstTeamName: string;
  FunctionNames: string[];
  FirstFunctionName: string;
  Phone: string;
  Email: string;
  PostCode: string;
  FamilyMemberNr: number | null;
  AccessKey: string;
}

export interface MemberSimpleListDto extends IdObject<number> {
  FirstName: string;
  LastName: string;
  PersonId: number | null;
  ReceivedHealthInsuranceCertificateOn: Date | null;
  WorkingYearName: string;
  Saldo: number;
}
export interface MemberForlistDto extends IdObject<number> {
  Number: number | null;
  NumberFederation: string;
  WorkingYearId: number | null;
  ExportCode: string;
  Saldo: number | null;
  FirstTeamName: string;
  FirstFunctionName: string;
  FamilyMemberNr: number | null;
  DroppedOut: boolean | null;
  DropOutHasBeenProcessed: boolean | null;
  MemberMoneyTeam1: number | null;
  MemberMoneyTeam2: number | null;
  MemberMoneyTeam3: number | null;
  MemberMoneyTeam4: number | null;
  MemberMoneyTeam5: number | null;
  FamilyDiscount: number | null;
  SocialDiscount: number | null;
  InvalidDiscount: number | null;
  OtherDiscount: number | null;
  InsuranceFee: number | null;
  Surplus: number | null;
  PayedAmount: number | null;
  AccessKey: string;
  PersonId: number | null;
  PublicSavedPersonId: number | null;
  MemberMoneySend: boolean | null;
  MemberMoneySendDate: Date | null;
  LicenseNumber: string | null;
}

export interface MemberImport extends Member {
  ValidationMessage: string;
  CreatedInOtherWorkingYear?: boolean;
  // Naam van het werkjaar waaruit dit lid komt wanneer het naar een ander werkjaar wordt
  // overgezet — voedt de waarschuwing bovenaan de import-preview.
  OtherWorkingYearName?: string;
  Done?: boolean;
  Error?: boolean;
}
